module.exports = __webpack_public_path__ + "assets/img/3202.d85ab746.png";